import { render, staticRenderFns } from "./order.vue?vue&type=template&id=7210ea9e&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=7210ea9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7210ea9e",
  null
  
)

export default component.exports